import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=bbf202ee&scoped=true&lang=pug&"
import script from "./Tab.vue?vue&type=script&lang=ts&"
export * from "./Tab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf202ee",
  null
  
)

export default component.exports